<template>
    <div class="login_info" v-loading="loading">
        <div class="login_info_box">
            <div class="top_box">
                <img src="../../assets/img/login/Frame.png" alt="">
                <span class="span1" @click="handle_home">首页</span>
                > 律师入驻
            </div>
            <div class="bom_box">
                <div class="title_box">
                    <div class="borders"></div>
                    <div class="text1">律师入驻</div>
                </div>
                <div class="form_box">
                    <div class="form_flex">
                        <div class="form_title">
                            <span>*</span>
                            选择类型
                        </div>
                        <div class="input2">
                            <el-select v-model="forms.type" placeholder="请选择">
                                <el-option v-for="(item, index) in ls_type" :key="index" :label="item.title"
                                    :value="item.type">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="form_flex_box">
                        <div class="form_flex">
                            <div class="form_title">
                                <span>*</span>
                                姓名
                            </div>
                            <div class="input2">
                                <el-input v-model="forms.name " placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                        <div class="form_flex">
                            <div class="form_title">
                                <span>*</span>
                                身份证号
                            </div>
                            <div class="input2">
                                <el-input v-model="forms.identity" placeholder="请输入内容"></el-input>

                            </div>
                        </div>
                    </div>

                    <div class="form_flex_box">
                        <div class="form_flex">
                            <div class="form_title">
                                <span>*</span>
                                律师执业资格证号码
                            </div>
                            <div class="input2">
                                <el-input v-model="forms.cert_num" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                        <div class="form_flex">
                            <div class="form_title">
                                <span>*</span>
                                手机号
                            </div>
                            <div class="input2">
                                <el-input v-model="forms.mobile" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                    </div>
                    <div class="form_flex_box">
                        <div class="form_flex">
                            <div class="form_title">
                                <span>*</span>
                                电子邮箱
                            </div>
                            <div class="input2">
                                <el-input v-model="forms.email" placeholder="请输入内容"></el-input>
                            </div>
                        </div>
                        <div class="form_flex">
                            <div class="form_title">
                                <span>*</span>
                                所在地区
                            </div>
                            <div class="input5">
                                <el-cascader placeholder="请选择城市名称" clearable v-model="area_ac" :options="area_list"  :props="props" @change="handleChange"></el-cascader>
                            </div>
                        </div>
                    </div>

                    <div class="form_flex" v-if="forms.type == 1">
                        <div class="form_title">
                            所在单位（律所）
                        </div>
                        <div class="input2">
                            <el-input v-model="forms.work_company" placeholder="请输入内容"></el-input>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title">
                            <span>*</span>
                            专业擅长
                        </div>
                        <div class="input3">
                            <el-input type="textarea"  placeholder="请输入内容" v-model="forms.serve"></el-input>

                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title">
                            <span>*</span>
                            个人简介
                        </div>
                        <div class="input3">
                            <el-input type="textarea"  placeholder="请输入内容" v-model="forms.info"></el-input>

                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title">
                            <span>*</span>
                            上传资格证扫描件
                        </div>
                        <div class="input_img">
                            <div class="img_text">请上传资格证内页扫描件，格式为jpg、png</div>
                            <div class="img_list">
                                <div class="img_item" v-for="(item,index) in cert_img">
                                    <!-- <img src="../../assets/img/login/img_up.png" alt="" class="imgs"> -->
                                    <img :src="item" alt="" class="imgs">
                                    <img src="../../assets/img/login/clear.png" alt="" class="img_clear" @click="handle_clear(index,'cert_img')">


                                </div>
                                <img src="../../assets/img/login/img_up.png" alt="" class="img_add" @click="handle_img_add('cert_img')">
                            </div>
                        </div>
                    </div>
                    <div class="form_flex">
                        <div class="form_title">
                            <span>*</span>
                            上传职业装照片
                            <br>
                            （用于个人简介）
                        </div>
                        <div class="input_img">
                            <div class="img_text">上传职业装照片（用于个人简介），格式为jpg、png</div>
                            <div class="img_list">
                                <div class="img_item" v-for="(item,index) in business_img">
                                    <!-- <img src="../../assets/img/login/img_up.png" alt="" class="imgs"> -->
                                    <img :src="item" alt="" class="imgs">

                                    <img src="../../assets/img/login/clear.png" alt="" class="img_clear" @click="handle_clear(index,'business_img')">


                                </div>
                                <img src="../../assets/img/login/img_up.png" alt="" class="img_add" @click="handle_img_add('business_img')" v-if="business_img.length==0">
                            </div>
                        </div>
                    </div>

                    <div class="form_flex">
                        <div class="form_title">
                            <!-- <span>*</span> -->
                            期望从网站中获得什么
                        </div>
                        <div class="input3">
                            <el-input type="textarea"  placeholder="请输入内容" v-model="forms.desire"></el-input>
                        </div>
                    </div>
                    <!-- <div class="form_flex">
                        <div class="form_title">
                            是否要成为区域合伙人
                        </div>
                        <div class="input4">
                            <el-radio v-model="forms.if_join" label="1">是</el-radio>
                            <el-radio v-model="forms.if_join" label="2">否</el-radio>
                        </div>
                    </div> -->
                    <div class="form_flex">
                        <div class="form_title">
                        </div>
                        <div class="btn_flex">
                            <div class="btns1" @click="handle_end">提交</div>
                            <div class="btns2" @click="$router.back()">取消</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <upload  v-show="false" ref="uploads" :show_type="true" :types="types"></upload>

    </div>
</template>
<script>
import {
    mapState
} from 'vuex'



import upload from '@/components/upload/upload.vue'

export default {
    components: {
        upload,

    },
    name: "homes",
    data() {
        return {
            types:JSON.stringify(['jpg','png']),
            loading: false,
            forms: {
                type:1,
                name:'',//姓名
                identity:'',//身份证号
                cert_num:'',//律师执业资格证号码
                mobile:'',//手机号
                email:'',//电子邮箱
                province:'',//省
                city:'',//市
                area:'',//区
                work_company:'',//所在单位
                serve:'',//擅长领域
                info:'',//个人简介
                cert_img:'',//资格证照片
                business_img:'',//职业装照片
                desire:'',//期望获得什么
                if_join:'0',
            },
            area_list: [],
            area_ac:[],
            props:{
                label:'name',
                value:'id',
                children:'children',
            },
          
            ls_type: [
                {
                    title: '执业律师（持律师实习证或律师执业证）',
                    type: 1,
                },
                {
                    title: '非执业律师（仅持法律从业资格证）',
                    type: 2,
                }
            ],
            cert_img:[],//资格证照片
            business_img:[],//职业装照片
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.forms.type=Number(this.$route.query.types)
        this.get_area()

    },
    methods: {
      
     
      
        //获取地区列表
        get_area(){
            this.$api("getChinaArea", {
                parent_id:1,
				type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.area_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        //地区选择触发
        handleChange(e){
            console.log('选择',e)
        },
        //回到首页
        handle_home(){
            this.$router.push({
                path:'/home'
            })
        },
        //触发上传
        handle_img_add(text){
            let datas={
                form_title:text,
            }
            this.$refs.uploads.uploadFile(datas)
        },
        //上传图片
        upload_url(res_data,datas){
            this[datas.form_title].push(res_data.path)
        },
        //删除图片
        handle_clear(index,text){
            this[text].splice(index,1)
        },
        //提交
        handle_end(){
            if(!this.forms.name){
                alertErr('请输入姓名')
                return
            }
            if(!this.forms.identity){
                alertErr('请输入身份证号')
                return
            }
            if(!this.forms.cert_num){
                alertErr('请输入律师执业资格证号码')
                return
            }
            
            if(!this.forms.mobile){
                alertErr('请输入手机号')
                return
            }
            let reg = /^((11[0-9])|(12[0-9])|(13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
            if (!reg.test(this.forms.mobile)) {
                alertErr('请输入正确的手机号')
                return 
            }
            if(!this.forms.email){
                alertErr('请输入电子邮箱')
                return
            }
            if(this.area_ac.length==0){
                alertErr('请选择所在地区')
                return
            }
            if(this.area_ac.length!=0){
                this.forms.province=this.area_ac[0]
                this.forms.city=this.area_ac[1]
                this.forms.area=this.area_ac[2]
            }
            if(!this.forms.serve){
                alertErr('请输入专业擅长')
                return
            } 
            if(!this.forms.info){
                alertErr('请输入个人简介')
                return
            }
            if(this.cert_img.length==0){
                alertErr('请上传资格证扫描件')
                return
            }
            this.forms.cert_img=this.cert_img.join(',')
            if(this.business_img.length==0){
                alertErr('请上传职业装照片')
                return
            }
            this.forms.business_img=this.business_img.join(',')

            this.loading=true
            this.$api("auth", {
                ...this.forms,
			}, "post").then((res) => {
                this.loading = false
                console.log('提交用户信息',res)
                if (res.code == 1) {
                    this.$router.push('/end_success')
                } else {
                    alertErr(res.msg)
                }
            });
            
        },


    },

}
</script>
<style scoped lang="less">
.login_info {
    width: 100%;
    // height: 680px;
    background-color: #F5F5F5;
    padding: 21px;
    padding-bottom: 100px;

    .login_info_box {
        width: 1440px;
        height: 100%;
        // background: #FFFFFF;
        margin: auto;

        .top_box {
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding-bottom: 22px;

            .span1 {
                cursor: pointer;
            }

            img {
                width: 14px;
                height: 14px;
                margin-right: 10px;
            }
        }

        .bom_box {
            height: 100%;
            background: #FFFFFF;

            .title_box {
                display: flex;
                align-items: center;
                padding-top: 26px;
                padding-bottom: 42px;

                .borders {
                    width: 4px;
                    height: 22px;
                    background: #377CFD;
                    border-radius: 3px 3px 3px 3px;
                }

                .text1 {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 20px;
                    color: #333333;
                    padding-left: 32px;
                }
            }

            .form_box {
                padding-left: 82px;
                padding-right: 120px;

                .form_flex_box {
                    display: flex;
                    align-items: baseline;
                    justify-content: space-between;
                }

                .form_flex {
                    display: flex;
                    // align-items: center;
                    padding-bottom: 24px;

                    .form_title {
                        width: 200px;
                        height: 40px;
                        line-height: 40px;
                        text-align: right;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        padding-right: 24px;
                        flex-shrink: 0;

                        span {
                            color: #FD4C5C;
                        }
                    }

                    .input2 {
                        display: flex;
                        align-items: center;

                        /deep/.el-select {
                            width: 400px;
                            height: 40px;
                        }

                        /deep/.el-input {
                            width: 400px;
                            height: 40px;
                        }

                        .input_text1 {
                            padding-left: 15px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #888888;

                        }

                    }

                    .input3 {
                        width: 100%;
                        height: 93px;

                        /deep/.el-textarea {
                            width: 100%;
                            height: 93px;

                            .el-textarea__inner {
                                width: 100%;
                                height: 93px;
                                resize: none
                            }
                        }
                    }

                    .input4 {}

                    .input5 {
                        width: 400px;

                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        /deep/.el-select {
                            width: 125px;
                        }
                    }

                    .input_img {
                        .img_text {
                            line-height: 40px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 12px;
                            color: #999999;
                        }

                        .img_list {
                            display: flex;
                            align-items: center;
                            flex-wrap: wrap;
                            padding-top: 8px;

                            .img_item {
                                position: relative;
                                width: 80px;
                                height: 80px;
                                margin-right: 10px;

                                .imgs {
                                    width: 80px;
                                    height: 80px;
                                }

                                .img_clear {
                                    position: absolute;
                                    right: 0;
                                    top: 0;
                                    cursor: pointer;
                                    width: 20px;
                                    height: 20px;
                                }

                            }

                            .img_add {
                                width: 80px;
                                height: 80px;
                                cursor: pointer;
                            }
                        }
                    }

                    .btn_flex {
                        display: flex;
                        align-items: center;

                        .btns1 {
                            width: 134px;
                            height: 40px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #FFFFFF;

                        }

                        .btns2 {
                            width: 134px;
                            height: 40px;
                            background: #FFFFFF;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;

                            margin-left: 10px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #377CFD;

                        }
                    }
                }
            }
        }
    }
}
</style>